export default __webpack_public_path__ + "static/media/2.b5c9ce12.svg";